module.exports = __webpack_public_path__ + "static/media/14UNEP18.7a2bd41e.jpg";